// src/components/FileInfoCard.tsx
import React, { useState } from 'react';
import { FileText, HardDrive, Hash, Activity, Copy, Check } from 'lucide-react';

interface FileInfoCardProps {
  file: {
    name: string;
    size_bytes: number;
    sha256: string;
    entropy: number;
    possibly_packed: boolean;
  };
  threatLevel: string;
}

const FileInfoCard: React.FC<FileInfoCardProps> = ({ file, threatLevel }) => {
  const [copied, setCopied] = useState(false);
  const isClean = threatLevel === 'CLEAN';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(file.sha256);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const formatSize = (bytes: number) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  };

  return (
    <div className="info-card">
      <h3 className="card-title">File Info</h3>
      <div className="info-row">
        <span className="info-label"><FileText size={14} /> Filename</span>
        <span className="info-value mono">{file.name}</span>
      </div>
      <div className="info-row">
        <span className="info-label"><HardDrive size={14} /> Size</span>
        <span className="info-value">{formatSize(file.size_bytes)}</span>
      </div>
      <div className="info-row">
        <span className="info-label"><Hash size={14} /> SHA256</span>
        <div className="sha256-container">
          <span className="info-value mono">{file.sha256.substring(0, 32)}...</span>
          <button className="copy-button" onClick={copyToClipboard}>
            {copied ? <Check size={14} /> : <Copy size={14} />}
          </button>
        </div>
      </div>
      <div className="info-row">
        <span className="info-label"><Activity size={14} /> Entropy</span>
        <div className="entropy-container">
          <span className="info-value">{file.entropy.toFixed(4)}</span>
          {/* Only show packed badge if file is not clean and entropy is high */}
          {!isClean && file.possibly_packed && (
            <span className="packed-badge">Possibly packed</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileInfoCard;